import axios from './axios';

export const getOrderProcurementItems = (orderId) => axios.get(`orders/${orderId}/procurement-items`);

export const createOrderProcurementItem = (orderId, data) => axios.post(`orders/${orderId}/procurement-items`, data);

export const updateOrderProcurementItem = (id, data) => axios.put(`order-procurement-items/${id}`, data);

export const deleteOrderProcurementItem = (id) => axios.delete(`order-procurement-items/${id}`);

export const saveProcurementItemToCatalog = (id) => axios.post(`order-procurement-items/${id}/save-to-catalog`);

export const updateProcurementItemReceived = (id, quantity) => axios.patch(`order-procurement-items/${id}/receive`, { quantity_received: quantity });
